import type { ExperienceTech } from '@/teams/portfolio/components/section/experience-section/experience-data.ts'
import '@/teams/portfolio/components/section/experience-section/experience-tech-tags/experience-tech-tags.scss'

interface ExperienceTechTagsProps {
	tech: ExperienceTech[]
}

export function ExperienceTechTags({
	tech,
}: Readonly<ExperienceTechTagsProps>) {
	return (
		<div className='experience-tech-tags' data-testid={'experience-tech-tags'}>
			{tech.map((item, index) => (
				<span
					className={`experience-tech-tags__tag experience-tech-tags__tag--${item.category}`}
					key={item.name}
					style={{ animationDelay: `${index * 50}ms` }}>
					{item.name}
				</span>
			))}
		</div>
	)
}
